import React from "react";
import { ReactComponent as FilterIcon } from '../../assets/icons/filter.svg';
import { ReactComponent as NotificationsIcon } from '../../assets/icons/notifications.svg';
import { ReactComponent as AnalyticIcon } from '../../assets/icons/analytic.svg';
import { ReactComponent as StructuredIcon } from '../../assets/icons/structured-selections.svg';
import { ReactComponent as ExportIcon } from '../../assets/icons/export-publications.svg';
import { ReactComponent as UsersCountIcon } from '../../assets/icons/users_count.svg';
import { ReactComponent as InteractiveIcon } from '../../assets/icons/interactive-dashboards.svg';
import { ReactComponent as SavingFiltersIcon } from '../../assets/icons/saving_filters.svg';
import AdvantageItem from "./advantage-item/advantage-item";
import EchoButton from "pages/landing-page/items/echo-button/echo-button";
import s from "./advantages.module.scss";


const Advantages = (props) => {

    const getIconByTitle = (title) => {
        switch(title){
            case 'CONVENIENT_FILTERING':
                return <FilterIcon />;
            case 'NOTIFICATIONS_ONLNE':
                return <NotificationsIcon />;
            case 'EXTENDED_ANALYTIC':
                return <AnalyticIcon />;
            case 'STRUCTURED_SELECTION':
                return <StructuredIcon />;
            case 'EXPORT_PUBLICATIONS':
                return <ExportIcon />;
            case 'USERS_NUMBER':
                return <UsersCountIcon />;
            case 'INTERCATIVE_DASHBOARDS':
                return <InteractiveIcon />;
            case 'SAVING_FILTERS':
                return <SavingFiltersIcon />;
        }
    }

    const showDemoModal = (isShow) => {
        props.setShowDemo();
    }

    let advantagesLeft = [];
    let advantagesRight = [];

    props.advantagesMenu.forEach((k, i) => 
        
                                i < 4   ? advantagesLeft.push(<AdvantageItem {...k} key={i} getIconByTitle={getIconByTitle} getValue={props.getValue}/>)
                                        : advantagesRight.push(<AdvantageItem {...k} key={i} getIconByTitle={getIconByTitle} getValue={props.getValue}/>)
                                );

    return (
        <div className={s.Advantages}>
            <div className={s.AdvantagesBlocks}>
                <div className={s.AdvantagesLeftBlock}>
                    {advantagesLeft}
                </div>
                <div className={s.advantagesCenter}>
                    <div className={s.AdvantagesTitle}>
                        <span>{ props.getValue('ADVANTAGES') }</span>
                        <span className={s.blueText}>Echo Analytics</span>
                    </div>
                    <EchoButton title={props.getValue('GET_DEMO_ACCESS')} styles={{height: '54px'}} callback={showDemoModal}/>
                </div>
                <div className={s.AdvantagesRightBlock}>
                    {advantagesRight}
                </div>
                
            </div>
            
        </div>
    )
}

export default Advantages;